import { useUser } from '@fs/zion-user'
import { useChatOverlayContext } from '../components/chat/ChatOverlayProvider'

export default function useOpenSignUpDialog() {
  const user = useUser()
  const { setIsOpen } = useChatOverlayContext()
  return (e) => {
    // if not signed in, prevent navigation and open the dialog instead
    if (!user.signedIn) {
      e.preventDefault()
      setIsOpen(true)
    }
  }
}
